module.exports = __webpack_public_path__ + "static/media/share-icon.4711114e.svg";